import { ROBOT_PART_REMOVE_CONFIRM_SUCCESS } from './removeRobotPartConfirmRequest';

export const removeRobotPartConfirmSuccess = () => ({
  type: ROBOT_PART_REMOVE_CONFIRM_SUCCESS,
  payload: {
  },
});
